/**
 * `.js-display-inview.is-transparent` 要素が画面内に入ったら `.is-transparent` を削除
 */
export default function displayInView() {
  // スクロールでviewportに入ってきたら表示
  if (window.IntersectionObserver !== undefined) {
    // IntersectionObserverが利用可能
    const observer = new IntersectionObserver(
      entries => {
        for (let i = 0; i < entries.length; i += 1) {
          /* if(entries[i].intersectionRatio>0.1){ */
          if (entries[i].isIntersecting) {
            entries[i].target.classList.remove('is-transparent');
            observer.unobserve(entries[i].target);
          }
        }
      },
      { threshold: [0.1] },
    );
    Array.from(document.getElementsByClassName('js-display-inview')).forEach((a, i) => {
      observer.observe(document.getElementsByClassName('js-display-inview')[i]);
    });
  } else {
    // IntersectionObserverが利用不可
    const $targets = document.querySelectorAll('.js-display-inview');
    let timerOfScroll = null;
    window.scroll(() => {
      clearTimeout(timerOfScroll);
      timerOfScroll = setTimeout(() => {
        $targets.forEach(target => {
          if (window.scrollTop() + window.clientHeight / 2 > target.offset().top) {
            target.classList.remove('is-transparent');
          }
        });
      }, 100);
    });
  }
}
